const custodianAccountView_ColumnDefs = [
  { headerName: 'Account Code', field: 'accountCode', width: 160 },
  { headerName: 'Account Desc', field: 'accountDesc', width: 220 },
  { headerName: 'Custodian', field: 'custodianCode', width: 160 },
  {
    headerName: 'Fund',
    field: 'fundCode',
    width: 160,
    // cellRenderer: 'agGroupCellRenderer',
  },
  {
    headerName: 'AccountType',
    field: 'accountType',
    width: 120,
  },
  { headerName: 'PnlEngineType', field: 'pnlEngineType', width: 160 },
  {
    headerName: 'IsActive',
    field: 'isActive',
    width: 90,
  },
  { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 140 },
  { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
]

export default custodianAccountView_ColumnDefs
